import React from 'react'
import { useIntl } from 'react-intl'

import { ThemeButton } from '../../../../ui'
import { Box } from '@mui/material'
import { useModalContext } from '../../../../ui/modal'
import { NewManager } from '../new-manager'

export const NewManagerBtn = () => {
  const { formatMessage } = useIntl()
  const {
    actions: { open },
  } = useModalContext()

  const handleAddNewManager = () => {
    open({
      Component: NewManager,
      type: 'responsive',
      closable: true,
      maxWidth: 'md',
    })
  }

  return (
    <Box ml={2} mr={2}>
      <Box display="flex" flexDirection="row" style={{ position: 'relative' }}>
        <ThemeButton color="primary" labelM="sm" onClick={handleAddNewManager}>
          {formatMessage({ id: 'pages.managers.newmanager.button.label' })}
        </ThemeButton>
      </Box>
    </Box>
  )
}
